define('modules/accounts/router',['require','exports','module','jquery','backbone','modules/private/index','./view','./users/index','./companies/index','./groups/index','./status/index','./security/index'],function (require, exports, module) {
  "use strict";

  var $ = require("jquery");
  var Backbone = require("backbone");
  var Private = require("modules/private/index");

  var MainView = require("./view");
  var Users = require("./users/index");
  var Companies = require("./companies/index");
  var Groups = require("./groups/index");
  var Status = require("./status/index");
  var Security = require("./security/index");

  var group;

  var init = function (activeTab, callback, groupId) {
    var linkGruopId = "";
    if (groupId) {
      linkGruopId = "/group/" + groupId;
    }

    Private.init(
      function (me) {
        var setGroupId = me.getGroup();

        if (groupId) {
          setGroupId = groupId;
        }

        group = new Groups.Model({
          id: setGroupId,
        });

        group.fetch({
          success: function () {
            var mainView = new MainView({
              el: "#content",
              activeTab:
                typeof activeTab === "function" ? activeTab(me) : activeTab,
              model: me,
              linkGruopId: linkGruopId,
              group: group,
            });
            mainView.render();

            callback(me, group);
          },
        });
      },
      null,
      true
    );
  };

  var accountsTabContent = "#accounts-tab-content";

  module.exports = Backbone.Router.extend({
    initialize: function () {},
    routes: {
      "accounts(/)": "accounts",
      "accounts/users(/)(/group/:group_id)": "userList",
      "accounts/user/me(/)(/group/:group_id)": "userMe",
      "accounts/user/new(/)(/group/:group_id)": "userNew",
      "accounts/user/:id(/group/:group_id)": "userDetail",
      "accounts/companies(/)(/group/:group_id)": "companyList",
      "accounts/company/new(/)(/group/:group_id)": "companyNew",
      "accounts/company/:id(/)(/group/:group_id)": "companyDetail",
      "accounts/company/delete/:id": "companyDelete",
      "accounts/status(/)(/group/:group_id)": "status",
      "accounts/status/mdirector(/)(/group/:group_id)": "statusMDirector",
      "accounts/status/landings(/)(/group/:group_id)": "statusLandings",
      "accounts/security(/group/:group_id)": "accountSecurity",
    },

    accounts: function () {
      var self = this,
        activeTabFunc = function (me) {
          return me.isAdmin() ? "status" : "me";
        };

      init(activeTabFunc, function (me, group) {
        if (me.isAdmin()) {
          self.showStatus(me, group);
        } else {
          self.userMe();
        }
      });
    },

    userDetail: function (id, group_id) {
      var self = this;
      init(
        "users",
        function (me, group) {
          self.showUser(id, me.getRole(), false, me);
        },
        group_id
      );
    },

    userMe: function (group_id) {
      var self = this;
      init(
        "me",
        function (me, group) {
          if (me && me.getUID()) {
            self.showUser(me.getUID(), me.getRole(), true, me);
          }
        },
        group_id
      );
    },

    showUser: function (id, role, myself, me) {
      var user = new Users.Model({
        id: id,
      });

      var userDetailView = new Users.Views.Detail({
        el: accountsTabContent,
        model: user,
        role: role,
        myself: myself,
        group: group,
        me: me,
      });
      user.fetch();
    },

    userNew: function (group_id) {
      init(
        "users",
        function (me, group) {
          var user = new Users.Model();
          user.set("services", group.get("services"));
          var userDetailView = new Users.Views.Detail({
            el: accountsTabContent,
            model: user,
            role: me.getRole(),
            group: group,
            me: me,
          });
          userDetailView.render();
        },
        group_id
      );
    },

    userList: function (group_id) {
      init(
        "users",
        function (me, group) {
          var users = new Users.Collection();
          var usersView = new Users.Views.List({
            el: accountsTabContent,
            collection: users,
            me: me,
            group: group,
          });
          users.fetch({ data: $.param({ groupId: group_id }) });
        },
        group_id
      );
    },

    companyDelete: function (companyId) {
      var self = this;
      init("companies", function (me, group) {
        var companies = new Companies.Model({
          id: companyId,
        });
        var companiesDeleteView = new Companies.Views.Delete({
          el: accountsTabContent,
          model: companies,
        });
        companiesDeleteView.render();
      });
    },

    companyDetail: function (companyId, group_id) {
      var self = this;
      init(
        "companies",
        function (me, group) {
          self.showCompany(companyId, me);
        },
        group_id
      );
    },

    companyList: function (group_id) {
      init(
        "companies",
        function (me, group) {
          var companies = new Companies.Collection();
          var companiesView = new Companies.Views.List({
            el: accountsTabContent,
            collection: companies,
            group: group,
            me: me,
          });
          companies.fetch({ data: $.param({ groupId: group_id }) });
        },
        group_id
      );
    },

    companyNew: function (group_id) {
      init(
        "companies",
        function (me, group) {
          var companies = new Companies.Model();
          var newCompany = { services: group.get("services") };
          companies.set(newCompany);
          var companyNewView = new Companies.Views.Detail({
            el: accountsTabContent,
            model: companies,
            group: group,
            me: me,
          });
          companyNewView.render();
        },
        group_id
      );
    },

    showCompany: function (id, me) {
      var company = new Companies.Model({
        id: id,
      });
      var companyDetailView = new Companies.Views.Detail({
        el: accountsTabContent,
        model: company,
        group: group,
        me: me,
      });
      company.fetch();
    },

    showStatus: function (me, group) {
      Status.init(accountsTabContent, me, group, group.getFirstService());
    },

    status: function (group_id) {
      init(
        "status",
        function (me, group) {
          Status.init(accountsTabContent, me, group, group.getFirstService());
        },
        group_id
      );
    },

    statusMDirector: function (group_id) {
      init(
        "status",
        function (me, group) {
          Status.init(accountsTabContent, me, group, "mdirector");
        },
        group_id
      );
    },

    statusLandings: function (group_id) {
      init(
        "status",
        function (me, group) {
          Status.init(accountsTabContent, me, group, "landings");
        },
        group_id
      );
    },

    accountSecurity: function (group_id) {
      var model = new Security.Model();
      init(
        "security",
        function (me, group) {
          var securityView = new Security.View({
            el: accountsTabContent,
            model: model,
            me: me,
            group: group,
            subTab: "securityData",
          });
          model.set("id", group.get("id"));
          model.fetch();
        },
        group_id
      );
    },
  });
});

